import { CommonModule } from '@angular/common';
import { Component, computed, effect, input } from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';

@Component({
  selector: 'debtor-panel-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  imports: [CommonModule],
  providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
})
export class StepperComponent extends CdkStepper {
  linearModeSelected = true;
  indexValue = input.required<number>();
  value = computed(() => this.indexValue());

  constructor() {
    super();
    effect(() => {
      this.selectedIndex = this.value();
    });
  }
}
